export const FormatirajTelefonskoStevilko = {
  methods: {
    VrniFormatiranoTelefonsko (prenosniParameter, tipStevilke, dodajKlicno = false, dodajPlus = true) {
      if (typeof prenosniParameter !== 'undefined' && prenosniParameter !== '') {
        let stringNumber = String(prenosniParameter)
        if (dodajKlicno) stringNumber = '386' + stringNumber.substring(1)
        let formatiranaStevilka = ''
        if (tipStevilke === '5') {
          formatiranaStevilka = (dodajPlus ? '+' : '') +
            stringNumber.replace(/(\d{3})(\d{2})(\d{3})(\d{3})/, '$1 $2 $3 $4')
        } else {
          formatiranaStevilka = (dodajPlus ? '+' : '') +
            stringNumber.replace(/(\d{3})(\d{1})(\d{3})(\d{4})/, '$1 $2 $3 $4')
        }
        return formatiranaStevilka
      }
      return ''
    },
    VrniFormatUmtsStevilke (param) {
      let pregledanaStevilka = ('' + param).replace(/\D/g, '')
      let ujemanje = pregledanaStevilka.match(/^(\d{3})(\d{3})(\d{3})$/)
      if (ujemanje) {
        let novFormatUjemanja1 = ujemanje[1].substring(1)
        return '+386 ' + novFormatUjemanja1 + ' ' + ujemanje[2] + ' ' + ujemanje[3]
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js